import { Api } from "./api"

export class NumberOfLicenseApi extends Api {
  constructor() {
    super('number_of_licenses', ['numberOfLicenses'])
  }
}
